export default __webpack_public_path__ + "static/media/icon-grid-radio.4abdefbd.svg";